export enum InvitationTemplatesStep {
  CHANNEL = 'channel',
  EMAIL = 'email',
  WHATSAPP = 'whatsapp'
}
